
(() => {
  'use strict';

  const header = document.querySelector('[data-muah-header]');
  if (!header) return;

  // Texte aus snippets/muah-i18n-js.liquid (window.MUAH_T), deutscher Fallback
  const T = (k, fb) => (window.MUAH_T && window.MUAH_T[k]) || fb;
  const ROOT = window.MUAH_ROOT || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const stickyMode = header.dataset.stickyMode || 'scroll-up';

  if (stickyMode !== 'off') {
    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-stuck', y > 4);
      if (stickyMode === 'scroll-up') {
        if (y > 100 && y > lastY) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
  }

  const drawer = document.querySelector('[data-muah-mobile-drawer]');
  const toggleBtn = document.querySelector('[data-muah-menu-toggle]');
  const closeBtns = document.querySelectorAll('[data-muah-menu-close]');

  // Drawer-Inhalt beginnt exakt unter dem (sichtbaren) Header.
  const setDrawerTop = () => {
    const b = Math.round(header.getBoundingClientRect().bottom); // reale Unterkante inkl. evtl. Offset
    if (b > 0) document.documentElement.style.setProperty('--muah-drawer-top', b + 'px');
  };

  const openDrawer = () => {
    if (!drawer) return;
    header.classList.remove('is-hidden');
    drawer.hidden = false;
    drawer.offsetHeight; // reflow
    drawer.classList.add('is-open');
    setDrawerTop();
    requestAnimationFrame(setDrawerTop);
    document.body.classList.add('muah-no-scroll');
    if (toggleBtn) {
      toggleBtn.classList.add('is-opened');
      toggleBtn.setAttribute('aria-expanded', 'true');
      toggleBtn.setAttribute('aria-label', T('menu_close', 'Menü schließen'));
    }
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('muah-no-scroll');
    if (toggleBtn) {
      toggleBtn.classList.remove('is-opened');
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.setAttribute('aria-label', T('menu_open', 'Menü öffnen'));
    }
    setTimeout(() => { drawer.hidden = true; }, 340);
  };

  const toggleDrawer = () => {
    if (!drawer) return;
    if (drawer.classList.contains('is-open')) closeDrawer();
    else openDrawer();
  };

  if (toggleBtn) toggleBtn.addEventListener('click', toggleDrawer);
  closeBtns.forEach((b) => b.addEventListener('click', closeDrawer));

  window.addEventListener('resize', () => {
    if (drawer && drawer.classList.contains('is-open')) setDrawerTop();
  }, { passive: true });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  const cartCount = document.querySelector('[data-muah-cart-count]');
  const cartBtn = document.querySelector('[data-muah-cart-toggle]');
  let lastCount = cartCount ? parseInt(cartCount.textContent, 10) : NaN;
  const setCartCount = (n) => {
    if (!cartCount) return;
    const label = (n === 1
      ? T('cart_count_one', '[count] Artikel im Warenkorb')
      : T('cart_count_other', '[count] Artikel im Warenkorb')).replace('[count]', n);
    cartCount.textContent = String(n);
    cartCount.setAttribute('aria-label', label);
    if (cartBtn) cartBtn.setAttribute('aria-label', T('cart_open', 'Warenkorb öffnen, [label]').replace('[label]', label));
    cartCount.classList.toggle('is-empty', n === 0);
    if (n !== lastCount) {
      cartCount.classList.add('is-bumped');
      setTimeout(() => cartCount.classList.remove('is-bumped'), 320);
    }
    lastCount = n;
  };
  // Quellen: Muah-Schublade (muah-cart.js), Warenkorbseite (cart.js) und andere Skripte.
  // Ohne Zahl im Event (z. B. muah-toast.js) wird der Stand einmal von /cart.js gelesen.
  const refreshCartCount = () => {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => { if (cart && typeof cart.item_count === 'number') setCartCount(cart.item_count); })
      .catch(() => {});
  };
  document.addEventListener('muah:cart:updated', (e) => {
    if (e.detail && typeof e.detail.item_count === 'number') {
      setCartCount(e.detail.item_count);
      return;
    }
    refreshCartCount();
  });
  // Zurück-Navigation aus dem Browser-Cache: Zähler kann veraltet sein.
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCartCount(); });

  if (cartBtn) cartBtn.addEventListener('click', () => document.dispatchEvent(new CustomEvent('muah:cart:open')));

  const searchBtn = document.querySelector('[data-muah-search-toggle]');
  if (searchBtn) searchBtn.addEventListener('click', () => document.dispatchEvent(new CustomEvent('muah:search:open')));
})();
